export default {
    inserted: (el, binding) => {
        // 聚焦元素
        binding.addClass = () => {
            const { top } = el.getBoundingClientRect()
            const h = window.innerHeight || document.documentElement.clientHeight
            if (top <= h ) {
                if (el.className.indexOf(binding.value) == -1) {
                    // 下面单引号中间是一个空格
                    el.className =el.className + ' ' +  binding.value
                }
                if (binding.addClass) {
                    window.removeEventListener('scroll', binding.addClass)
                }
            }
        }
        window.addEventListener('scroll', binding.addClass)
        binding.addClass()
    },
    unbind: function (el, binding) {
        if (binding.addClass) {
            window.removeEventListener('scroll', binding.addClass)
        }
    }
}